<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Microsoft YaHei', 'PingFang SC', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scrollbar-width: thin;
  scrollbar-color: rgba(100, 116, 139, 0.24) transparent;
}

#app {
  width: 100%;
  min-height: 100vh;
  scrollbar-width: thin;
  scrollbar-color: rgba(100, 116, 139, 0.24) transparent;
}

html {
  scrollbar-width: thin;
  scrollbar-color: rgba(100, 116, 139, 0.24) transparent;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar,
#app *::-webkit-scrollbar {
  width: 8px !important;
  height: 8px !important;
}

html::-webkit-scrollbar-track,
body::-webkit-scrollbar-track,
#app *::-webkit-scrollbar-track {
  background: transparent !important;
}

html::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-thumb,
#app *::-webkit-scrollbar-thumb {
  min-height: 40px;
  background: rgba(100, 116, 139, 0.18) !important;
  border: 2px solid transparent !important;
  border-radius: 999px !important;
  background-clip: padding-box !important;
}

html::-webkit-scrollbar-thumb:hover,
body::-webkit-scrollbar-thumb:hover,
#app *:hover::-webkit-scrollbar-thumb {
  background: rgba(100, 116, 139, 0.34) !important;
  background-clip: padding-box !important;
}

html::-webkit-scrollbar-corner,
body::-webkit-scrollbar-corner,
#app *::-webkit-scrollbar-corner {
  background: transparent !important;
}

#app * {
  scrollbar-width: thin;
  scrollbar-color: rgba(100, 116, 139, 0.18) transparent;
}

a {
  text-decoration: none;
  color: inherit;
}

button {
  font-family: inherit;
}

input {
  font-family: inherit;
}
</style>
